/* eslint-disable max-len */
import React from 'react';

interface CircleXIconProps {
	color?: string;
}

const CircleXIcon: React.FC<CircleXIconProps> = ({color = '#EE5151'}) => {
	return (
		<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M7.5 15C11.6421 15 15 11.6421 15 7.5C15 3.35786 11.6421 0 7.5 0C3.35786 0 0 3.35786 0 7.5C0 11.6421 3.35786 15 7.5 15Z" fill={`${color}`}/>
			<path d="M13 11.625L3.375 2L2 3.375L11.625 13L13 11.625Z" fill="#fff"/>
			<path d="M11.625 2L2 11.625L3.375 13L13 3.375L11.625 2Z" fill="#fff"/>
		</svg>

	);
}

export default CircleXIcon;
